import categorysvg from "@/assets/svg/category.svg";
export default {
  path: "/category",
  redirect: "/category/index",
  meta: {
    icon: categorysvg,
    title: "款式管理",
    rank: 1
  },
  children: [
    {
      path: "/category/index",
      name: "category",
      component: () => import("@/views/category/index.vue"),
      meta: {
        title: "款式管理",
        keepAlive: false,
        roles: ["style"]
      }
    },
    {
      path: "/category/categoryManager",
      name: "categoryManager",
      component: () => import("@/views/category/categoryManager.vue"),
      meta: {
        title: "添加/修改款式",
        keepAlive: false,
        showLink: false
      }
    },
    {
      path: "/category/categoryDetail",
      name: "categoryDetail",
      component: () => import("@/views/category/categoryDetail.vue"),
      meta: {
        title: "款式",
        keepAlive: false,
        showLink: false
      }
    }
  ]
} as RouteConfigsTable;
